import { oosCanadaProductIds, oosUkProductIds, oosUsaProductIds } from "./geolocation-handler.js";

if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.initializeBartesianPricingUI();
        this.initializeMainProdForm();
        this.cloneMainProdForm();
        this.updateInputAndLabelIds();
        this.setMainFormContainer();
      }

      initializeBartesianPricingUI() {
        this.bartesianPricingUI = document.querySelector("bartesian-pricing-ui");
        this.productId = this.getAttribute("data-product-id");
        this.oosStates = disableStickyATC[this.productId];
        console.log("this.oosStates", this.oosStates);
      }

      async initializeMainProdForm() {
        if (this.bartesianPricingUI && this.bartesianPricingUI.shadowRoot) {
          const shadowRoot = this.bartesianPricingUI.shadowRoot;
          const bartesianPricingUIWrapper = shadowRoot.querySelector(
            ".bartesian-pricing-ui-wrapper.bartesian-pricing-ui-wrapper-pdp"
          );
          this.mainProdForm = bartesianPricingUIWrapper;
          this.copyOfMainProdForm = bartesianPricingUIWrapper.cloneNode(true);
        } else {
          this.mainProdForm = document.querySelector(
            ".product-form__container-custom-selector product-form.main-prod-form"
          );
          this.copyOfMainProdForm = this.mainProdForm.cloneNode(true);
        }

        console.log("this.mainProdForm", this.mainProdForm);
        console.log("this.copyOfMainProdForm", this.copyOfMainProdForm);

        if (this.mainProdForm) {
          window.addEventListener("scroll", this.scrollStickyATC.bind(this));
        }
      }

      cloneMainProdForm() {
        if (!this.copyOfMainProdForm) return;
        this.copyOfMainProdForm.classList.add("cloneNode");
      }

      updateInputAndLabelIds() {
        if (!this.copyOfMainProdForm) return;

        this.copyOfMainProdForm.querySelectorAll("input[type=radio]").forEach((input) => {
          input.id = `${input.id}-clone`;
        });

        this.copyOfMainProdForm.querySelectorAll("label").forEach((label) => {
          label.htmlFor = `${label.htmlFor}-clone`;
        });
      }

      async setMainFormContainer() {
        this.mainFormContainer = this.bartesianPricingUI
          ? this.bartesianPricingUI
          : this.mainProdForm;
      }

      scrollStickyATC() {
        const headerBottom = document
          .querySelector("#shopify-section-header")
          .getBoundingClientRect().bottom;
        const productFormBottom = this.mainFormContainer.getBoundingClientRect().bottom;

        let formHeight, marginHeight, stickyHeight;
        if (!this.classList.contains("stickyactive")) {
          formHeight = this.mainProdForm.offsetHeight;
          const formStyle = window.getComputedStyle(this.mainProdForm);
          marginHeight = parseFloat(formStyle.marginTop) + parseFloat(formStyle.marginBottom);
        } else {
          stickyHeight = this.offsetHeight;
        }

        // console.log("productForm", this.mainFormContainer);
        // console.log("productFormBottom", productFormBottom);

        // console.log("header", document.querySelector("#shopify-section-header"));
        // console.log("headerBottom", headerBottom);

        if (productFormBottom <= headerBottom && !this.classList.contains("stickyactive")) {
          this.getFormContents(formHeight, marginHeight);
          this.classList.add("stickyactive");
        } else if (productFormBottom > headerBottom && this.classList.contains("stickyactive")) {
          this.returnFormContents(stickyHeight);
          this.classList.remove("stickyactive");
        }
      }

      disableAtc() {
        console.log("Disabling ATC");
        const atcButton = this.querySelector("button.add-to-cart-btn");
        atcButton.setAttribute("disabled", true);
        atcButton.innerHTML = `<span class="sold-out">SOLD OUT</span>`;
        if (this.getAttribute("market-handle") === "australia-nz") {
          atcButton.innerHTML = `<span class="sold-out">Coming Soon</span>`;
        }
      }

      enableAtc() {
        console.log("Enabling ATC");
        const atcButton = this.querySelector("button.add-to-cart-btn");
        atcButton.removeAttribute("disabled");
        atcButton.innerHTML = `<div aria-hidden="true" class="add-to-cart-btnSmall__quantity">ADD TO CART</div>`;
      }

      async getFormContents(formHeight, marginHeight = 0) {
        if (formHeight && !isNaN(formHeight)) {
          this.mainFormContainer.style.height = `${formHeight + marginHeight}px`;
        }
        this.style.height = "auto";

        // Add Skio bundle elements if this is a Classic Box or Bundle
        const productType = this.getAttribute("data-product-type");
        if (productType === "Classic Box" || productType === "Bundle") {
          const variant = this.getAttribute("data-variant-id");
          const form = this.copyOfMainProdForm.querySelector('form[action*="/cart/add"]');

          if (form) {
            try {
              const response = await fetch(
                "https://api.skio.com/storefront-http/get-classic-box-v2",
                {
                  method: "POST",
                  body: JSON.stringify({
                    productVariantPlatformId: variant,
                  }),
                }
              );

              if (!response.ok) {
                throw new Error("Failed to get box");
              }

              const { ClassicBoxV2 } = await response.json();

              // Add hidden inputs to the form
              const hiddenInputs = document.createElement("div");
              hiddenInputs.style.display = "none";

              // Add isClassicBoxV2 input
              const isClassicBoxInput = document.createElement("input");
              isClassicBoxInput.type = "hidden";
              isClassicBoxInput.name = "properties[_isClassicBoxV2]";
              isClassicBoxInput.value = "true";
              hiddenInputs.appendChild(isClassicBoxInput);

              // Add inputs for each selectable product variant
              ClassicBoxV2.selectableProductVariants.forEach((item) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[_pv${item.platformId}]`;
                input.className = "skio-quantity-sync";
                input.value = 1;
                hiddenInputs.appendChild(input);
              });

              form.appendChild(hiddenInputs);
            } catch (error) {
              console.error("Error setting up Skio Classic Box:", error);
            }
          }
        }

        console.log("oosCanadaProductIds", oosCanadaProductIds);
        console.log("oosUkProductIds", oosUkProductIds);
        console.log("oosUsaProductIds", oosUsaProductIds);

        this.disableProductsByRegion(oosCanadaProductIds, "en-ca");
        this.disableProductsByRegion(oosUkProductIds, "en-gb");
        this.disableProductsByRegion(oosUsaProductIds, "");

        this.copyOfMainProdForm.querySelector(".quantity-selector")?.remove();
        // console.log("this.copyOfMainProdForm: ", this.copyOfMainProdForm);

        const bartesianPricingUI = this.copyOfMainProdForm.querySelector(
          ".bartesian-pricing-ui-inner-wrapper-pdp"
        );

        if (bartesianPricingUI) {
          this.setupBartesianPricingUI(bartesianPricingUI);
        }
        this.appendChild(this.copyOfMainProdForm);

        const storedGeoData = sessionStorage.getItem("geoDetails");
        if (storedGeoData) {
          console.log("Using stored geo details from session storage");
          const data = JSON.parse(storedGeoData);

          const regionCodeActions = {
            no_CA: ["AZ", "CA", "ID", "MT", "NV", "OR", "UT", "WA"],
            no_TX: ["KS", "NM", "AR", "LA", "OK", "TX", "CO", "WY"],
            no_IL: ["ND", "SD", "NE", "IL", "WI", "MN", "IA", "MO", "IN", "AK", "HI", "PR"],
            no_OH: ["WV", "OH", "MI", "KY", "VA"],
            no_PA: ["ME", "NH", "VT", "MA", "RI", "CT", "NJ", "DE", "MD", "NY", "PA", "DC"],
            no_DOTH: ["AL", "MS", "SC", "NC", "TN", "FL", "GA"],
          };

          const { country_code: country, region_code: regionCode } = data;

          console.log("checkRegionCodes", country, regionCode, this.oosStates);

          if (this.oosStates && this.oosStates.length > 0 && this.oosStates[0] !== "") {
            console.log("this.oosStates", this.oosStates);

            if (country === "US") {
              console.log("country US");
              for (const [key, regions] of Object.entries(regionCodeActions)) {
                if (this.oosStates.includes(key)) {
                  console.log("check point 1", key);
                  if (regions.includes(regionCode)) {
                    console.log("check point 1.1", key);
                    console.log(`Current State: ${regionCode}, Disabling ATC for ${key}`);
                    this.disableAtc();
                    return;
                  } else {
                    console.log("check point 1.2", key);
                    console.log(`Current State: ${regionCode}, Enabling ATC for ${key}`);
                    this.enableAtc();
                  }
                }
              }
              if (this.oosStates.includes("no_US")) {
                console.log("Disabling ATC for US");
                this.disableAtc();
              }
            } else if (country === "CA" && this.oosStates.includes("no_CAN")) {
              console.log("Disabling ATC for Canada");
              this.disableAtc();
            } else if (country === "GB" && this.oosStates.includes("no_UK")) {
              console.log("Disabling ATC for UK");
              this.disableAtc();
            }
          }
        }
      }

      disableProductsByRegion(productIds, region) {
        if (productIds.length === 0) return;

        const isDefaultRegion = region === "";
        const isRegionMatch = isDefaultRegion
          ? !window.location.href.includes("/en-ca/") && !window.location.href.includes("/en-gb/")
          : window.location.href.includes(`/${region}/`);

        if (!isRegionMatch) return;

        productIds.forEach((productId) => {
          if (this.copyOfMainProdForm.classList.contains("bartesian-pricing-ui-wrapper-pdp")) {
            this.disableBartesianPricingUiProduct(productId);
          } else {
            this.disableStandardProduct(productId);
          }
        });
      }

      disableBartesianPricingUiProduct(productId) {
        // console.log("Implementing Bartesian Pricing UI");
        const atcBtnWrapper = this.copyOfMainProdForm.querySelector(
          `[data-product-id="${productId}"]`
        );
        // console.log("atcBtnWrapper", atcBtnWrapper);
        if (atcBtnWrapper) {
          const atcButton = atcBtnWrapper.querySelector("button.add-to-cart-btn-pdp");
          if (atcButton) {
            atcButton.setAttribute("disabled", true);
            atcButton.innerHTML = "SOLD OUT";
          }
        }
      }

      disableStandardProduct(productId) {
        const formElement = this.copyOfMainProdForm.querySelector(
          `form[data-productid="${productId}"]`
        );
        if (formElement) {
          const submitButton = formElement.querySelector(
            ".product-form__buttons button[type='submit']"
          );
          if (submitButton) {
            submitButton.setAttribute("disabled", true);
            submitButton.innerHTML = "SOLD OUT";
          }
          const variantSelect = formElement.querySelector("variant-selects select");
          if (variantSelect) {
            variantSelect.setAttribute("disabled", true);
          }
        }
      }

      setupBartesianPricingUI(bartesianPricingUI) {
        if (!bartesianPricingUI.querySelector(".price-wrapper")) {
          const priceElement = bartesianPricingUI.querySelector(".price");
          const defaultPriceElement = bartesianPricingUI.querySelector(".default-price-per-unit");
          const uiType = this.bartesianPricingUI.getAttribute("ui-type");
          const variantId = this.bartesianPricingUI.getAttribute("variant-id");
          // console.log("uiType: ", uiType);
          // console.log("variantId: ", variantId);

          if (priceElement) {
            const wrapperDiv = document.createElement("div");
            wrapperDiv.classList.add("price-wrapper");
            priceElement.classList.add("price-font-bold");
            priceElement.parentNode.insertBefore(wrapperDiv, priceElement);
            wrapperDiv.appendChild(priceElement);

            if (uiType === "non-variety") {
              wrapperDiv.appendChild(defaultPriceElement);
            }
          }

          bartesianPricingUI
            .querySelector("button.add-to-cart-btn-pdp")
            .addEventListener("click", async () => {
              this.bartesianPricingUI.toggleQuantitySelector(variantId);
              const quantitySelector =
                this.bartesianPricingUI.shadowRoot.querySelector(".quantity-selector");
              quantitySelector.style.position = "fixed";
              quantitySelector.style.display = "block";

              if (window.innerWidth > 768) {
                quantitySelector.style.bottom = "-10rem";
              }
            });
        }
      }

      returnFormContents(stickyHeight = 0) {
        this.mainFormContainer.style.height = "auto";
        this.style.height = `${stickyHeight}px`;

        this.removeChild(this.copyOfMainProdForm);
      }
    }
  );
}
